import { RootState } from "../../../../store";

import { FormDataInputs } from "./summary.slice";

export const selectFormData = (store: RootState): FormDataInputs =>
  store.ocProperty.summary;
